exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trip-inclusion-subheader[data-v-46ec594a] {\n    font-size: 0.875rem;\n    line-height: 1.4;\n}\n", ""]);

// exports
